module.exports = __webpack_public_path__ + "7b14cb0171852b043dadbeb9aa869dc2.png";